import { render, staticRenderFns } from "./GroupHistoryPreview.vue?vue&type=template&id=06c95ec2&scoped=true&"
import script from "./GroupHistoryPreview.vue?vue&type=script&lang=ts&"
export * from "./GroupHistoryPreview.vue?vue&type=script&lang=ts&"
import style0 from "./GroupHistoryPreview.vue?vue&type=style&index=0&id=06c95ec2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c95ec2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
